import { motion } from "framer-motion";
import { CalendarCheck, Check, MessageCircle } from "lucide-react";
import { BOOKING_URL, IMG, waUrl } from "../config";
import { trackCta, withAttribution } from "../attribution";
import { ChapterHead } from "./ChapterHead";

export const Direct = ({ t }) => (
    <section data-testid="direct-section" className="relative overflow-hidden py-20 sm:py-28">
        <span aria-hidden className="font-display pointer-events-none absolute -right-6 -top-10 z-0 select-none text-[16rem] font-black leading-none text-[rgba(242,50,24,0.08)] sm:text-[22rem]">04</span>
        <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-6 lg:grid-cols-2 lg:gap-16">
            <div>
                <ChapterHead chapter={t.direct.chapter} label={t.direct.label} title={t.direct.title} />
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                    className="max-w-lg text-sm leading-relaxed text-[#1b0b06]/70 sm:text-base"
                >
                    {t.direct.text}
                </motion.p>
                <ul className="mt-8 space-y-4">
                    {t.direct.benefits.map((b, i) => (
                        <motion.li
                            key={b}
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.5, delay: i * 0.1 }}
                            data-testid={`direct-benefit-${i}`}
                            className="flex items-start gap-3"
                        >
                            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#f23218] text-white">
                                <Check size={14} strokeWidth={3} />
                            </span>
                            <span className="text-sm font-semibold text-[#1b0b06] sm:text-base">
                                <span className="bg-[linear-gradient(transparent_62%,#faff00_62%)]">{b}</span>
                            </span>
                        </motion.li>
                    ))}
                </ul>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                    className="mt-10 flex flex-wrap items-center gap-3"
                >
                    <a
                        href={withAttribution(BOOKING_URL)}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={trackCta("book_now_click", "section_book_direct")}
                        data-testid="direct-book-btn"
                        className="flex items-center gap-2 rounded-full bg-[#f23218] px-7 py-3.5 text-sm font-extrabold uppercase tracking-wider text-white shadow-[0_8px_30px_rgba(242,50,24,0.4)] transition-transform hover:scale-105"
                    >
                        <CalendarCheck size={18} />
                        {t.direct.book}
                    </a>
                    <a
                        href={waUrl(t.waMsg)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="direct-whatsapp-btn"
                        onClick={trackCta("whatsapp_click", "section_book_direct")}
                        className="flex items-center gap-2 rounded-full border-2 border-[#1b0b06] px-7 py-3.5 text-sm font-extrabold uppercase tracking-wider text-[#1b0b06] transition-colors hover:bg-[#1b0b06] hover:text-[#fbf3e8]"
                    >
                        <MessageCircle size={18} />
                        {t.direct.whats}
                    </a>
                </motion.div>
                <p className="mt-4 text-xs font-semibold uppercase tracking-wider text-[#1b0b06]/50">{t.direct.note}</p>
            </div>
            <div className="relative hidden lg:block">
                <motion.div
                    initial={{ opacity: 0, y: 40, scale: 0.97 }}
                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden rounded-3xl shadow-2xl"
                >
                    <img src={IMG.interior} alt="Entrada do Matianellu Hostel" className="h-[560px] w-full object-cover" />
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 30, rotate: 3 }}
                    whileInView={{ opacity: 1, y: 0, rotate: 3 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.35 }}
                    className="absolute -bottom-10 -right-6 w-48 overflow-hidden rounded-2xl border-4 border-[#fbf3e8] shadow-xl"
                >
                    <img src={IMG.kitchen} alt="Hóspedes do Matianellu" className="h-36 w-full object-cover" />
                </motion.div>
            </div>
        </div>
    </section>
);
